<template>
  <div class="subscription-page">
    <!-- Header Section -->

    <div class="header">
      <div class="back-button" @click="goBack">
        <img src="@/assets/img/back-white.svg" alt="Back" />
      </div>
      <div class="user-info-container">
        <div class="user-info">
          <h1>Hi, {{ userName }}</h1>
        </div>
        <div class="action-button">
          <button class="recharge-button" @click="goToRechargeHistory">
            充值记录
          </button>
        </div>
      </div>

      <div class="user-stats">
        <div class="stat-item">
          <div class="stat-label">算力值余额</div>
          <div class="stat-value">{{ totalBalance }}</div>
        </div>
        <div class="stat-item">
          <div class="stat-label">服务器剩余时长 (天)</div>
          <div class="stat-value">{{ totalServerTime }}</div>
        </div>
      </div>
    </div>

    <!-- Subscription Options Section -->
    <div
      class="subscription-container"
      :class="{ 'is-credit': activeTab === 'credit' }"
    >
      <!-- Tabs -->
      <div
        class="tab-container"
        :class="{ 'is-credit': activeTab === 'credit' }"
      >
        <div class="tab-slider">
          <div
            class="tab"
            :class="{ active: activeTab === 'credit' }"
            @click="activeTab = 'credit'"
          >
            算力值充值
          </div>
          <div
            class="tab"
            :class="{ active: activeTab === 'service' }"
            @click="activeTab = 'service'"
          >
            服务器套餐
          </div>
        </div>
      </div>

      <!-- Subscription Plans -->
      <template v-if="activeTab === 'service'">
        <div class="plans-container">
          <div
            @click="serverTab = index"
            :class="{
              'plan-card': true,
              active: serverTab === index,
            }"
            v-for="(item, index) in serverList"
            :key="item.id"
          >
            <div class="discount-label" v-if="item.discountText">
              <!--          <div v-if="!!item.discount" class="discount-label">-->
              <!--            限时{{ item.discount }}折-->
              {{ item.discountText }}
            </div>
            <div class="plan-duration">
              {{ item.name }}<span class="time-tag">{{ item.timeText }}</span>
            </div>
            <!-- <div class="sub-title">{{ item.subtitle }}</div> -->
            <div class="plan-price">
              {{ item.price }}<span class="price-unit">算力值</span>
            </div>
            <div class="plan-description" v-if="item.description">
              <div
                class="plan-description-item"
                v-for="(desc, index) in item.description"
                :key="index"
              >
                {{ desc }}
              </div>
            </div>
            <div v-if="!!item.discount" class="original-price">
              {{ item.originPrice }}算力值
            </div>
          </div>
        </div>
        <div class="tip-container">
          <div class="tip-text">有更多定制化需求，联系我们为你提供专属套餐</div>
          <div class="tip-button" @click="showQrCode">
            联系客服<van-icon name="arrow" />
          </div>
        </div>
      </template>

      <div
        class="balance-container"
        :class="{ 'is-credit': activeTab === 'credit' }"
        v-else
      >
        <div
          @click="balanceTab = index"
          :class="{
            'balance-card': true,
            active: balanceTab === index,
          }"
          v-for="(item, index) in balanceList"
          :key="index"
        >
          <div class="title">
            {{ item.amount }}<span class="title-unit">算力值</span>
          </div>
          <div class="count">
            <span class="unit">¥ </span>{{ item.price
            }}<span class="price">￥{{ parseInt(item.originPrice) }}元</span>
          </div>
        </div>
        <div
          @click="balanceTab = balanceList.length"
          :class="{
            'balance-card': true,
            'custom-balance': true,
            active: balanceTab === balanceList.length,
          }"
          :key="balanceList.length"
        >
          <input
            class="count-input"
            placeholder="输入算力值"
            v-model="customAmount"
            @input="handleCustomAmountInput"
            @keydown="handleKeyDown"
            @paste="handlePaste"
            type="text"
            inputmode="numeric"
            pattern="[0-9]*"
            maxlength="10"
            autocomplete="off"
          />
          <div class="price custom-price">￥{{ customPrice }}元</div>
        </div>
      </div>
    </div>

    <div class="pay-content">
      <div class="pay-bar" v-if="activeTab === 'credit'">
        <!-- 协议勾选组件 -->
        <div class="checkbox-wrapper">
          <van-checkbox
            checked-color="#219653"
            icon-size="18px"
            v-model="isAgreementChecked"
          >
            <span class="agreement-text"
              >已阅读并同意
              <span class="agreement-text-link" @click.stop="showVipAgreement"
                >金声玉亮系列会员服务协议</span
              ></span
            >
          </van-checkbox>
        </div>
      </div>

      <!-- Redeem Button -->
      <div
        class="redeem-button-container"
        :class="{ 'is-credit': activeTab === 'credit' }"
      >
        <button class="redeem-button" @click="redeem">
          {{ activeTab === "service" ? "去兑换" : "去充值" }}
        </button>
      </div>
    </div>

    <!-- 状态弹窗组件 -->
    <status-popup
      v-model="statusPopupVisible"
      :type="statusPopupType"
      :title="statusPopupTitle"
      :description="statusPopupDescription"
      :auto-close-delay="statusPopupAutoClose"
      :showConfirmButton="showStatusPopupConfirmButton"
      :showCancelButton="showStatusPopupCancelButton"
      :confirmText="statusPopupConfirmButtonText"
      :cancelText="statusPopupCancelButtonText"
      @confirm="onStatusPopupConfirm"
      @cancel="onStatusPopupClose"
      @close="onStatusPopupClose"
    />

    <!-- 风险揭示书弹窗 -->
    <agreement-popup
      v-model="riskPopupVisible"
      title="风险揭示书"
      confirm-button-text="已知晓"
      cancel-button-text="取消"
      :htmlContent="true"
      :content="riskContent"
      @confirm="handleRiskConfirm"
      @cancel="handleRiskCancel"
    />

    <!-- 充值协议弹窗 -->
    <agreement-popup
      v-model="agreementPopupVisible"
      title="充值协议"
	  :htmlContent="true"
	  :content="payContent"
      confirm-button-text="同意"
      cancel-button-text="返回上一步"
      @confirm="handleAgreementConfirm"
      @cancel="handleAgreementCancel"
      @close="onAgreementPopupClose"
    />

    <!-- 金声玉亮系列会员服务协议弹窗 -->
    <agreement-popup
      v-model="vipAgreementPopupVisible"
      title="金声玉亮系列会员服务协议"
      :htmlContent="true"
      :content="vipAgreementContent"
      :showConfirmButton="true"
      confirmButtonText="我知道了"
      :showCancelButton="false"
      :closeOnClickOverlay="true"
      @close="onVipAgreementClose"
      @confirm="onVipAgreementClose"
    />

    <!-- 支付状态查询弹窗 -->
    <Popup
      v-model="paymentStatusPopupVisible"
      :style="{
        boxSizing: 'border-box',
        width: '300px',
        borderRadius: '8px',
        padding: '24px 20px',
        background: '#ffffff',
      }"
      :overlay="true"
      :close-on-click-overlay="false">
      <div class="payment-status-popup">
        <div class="payment-popup-title">支付确认</div>
        <div class="payment-popup-desc">
          检测到您有一个待确认的订单，请确认您的支付状态
        </div>
        <div class="payment-popup-buttons">
          <van-button
            @click="handlePaymentConfirm(true)"
            color="#000"
            style="height: 44px; margin-bottom: 12px;"
            block
            round
            :loading="isCheckingPayment"
            >已支付完成</van-button
          >
          <van-button
            @click="handlePaymentConfirm(false)"
            color="#666"
            style="height: 44px;"
            block
            round
            plain
            >稍后支付</van-button
          >
        </div>
      </div>
	 
    </Popup>

    <!-- 支付错误弹窗（重构样式：上标题 / 中内容 / 下左右按钮） -->
    <Popup
      v-model="paymentErrorPopupVisible"
      :style="{
        boxSizing: 'border-box',
        width: '300px',
        borderRadius: '8px',
        padding: '24px 20px',
        background: '#ffffff',
      }"
      :overlay="true"
      :close-on-click-overlay="false"
    >
      <div class="payment-error-popup">
        <div class="popup-header">提示</div>
        <div class="popup-body">
          当前支付未完成，请添加客服微信协助处理!
        </div>
        <div class="wx-popup-qrcode">
          <img src="https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/kefu.jpg" alt="二维码" />
        </div>
        <div class="popup-footer">
          <van-button
            class="popup-cancel-btn"
            round
            plain
            color="#666"
            style="height: 40px;"
            @click="paymentErrorPopupVisible = false"
          >取消</van-button>
          <van-button
            class="popup-confirm-btn"
            round
            color="#000"
            style="height: 40px;"
            @click="paymentErrorPopupVisible = false"
          >确定</van-button>
        </div>
      </div>
    </Popup>

    <Popup
      v-model="qrCodeVisible"
      :style="{
        boxSizing: 'border-box',
        width: '270px',
        borderRadius: '8px',
        padding: '20px 16px',
        background: '#ffffff',
      }"
      :overlay="true"
      :close-on-click-overlay="true"
    >
      <div class="wx-qrcode-popup">
        <div class="wx-popup-title">联系客服</div>
        <div class="wx-popup-desc">
          请扫描二维码添加我们客服的联系方式，为你提供定制化的专属服务套餐
        </div>
        <div class="wx-popup-qrcode">
          <img
            src="https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/kefu.jpg"
            alt="二维码"
          />
        </div>
        <van-button
          type="primary"
          @click="qrCodeVisible = false"
          color="#000"
          style="height: 36px; margin-top: 20px;"
          block
          round
          >我知道了</van-button
        >
      </div>
    </Popup>
    <Popup
      v-model="rechargeAgreementPopupVisible"
      :style="{
        boxSizing: 'border-box',
        width: '272px',
        borderRadius: '8px',
        padding: '24px 16px 16px',
        background: '#ffffff',
      }"
      :overlay="true"
      :close-on-click-overlay="true"
    >
      <div class="recharge-agreement-popup">
        <div class="recharge-agreement-title">金声玉亮系列会员服务协议</div>
        <div class="recharge-agreement-content">
          已阅读并同意
          <span
            class="recharge-agreement-content-link"
            @click.stop="showVipAgreement"
            >金声玉亮系列会员服务协议</span
          >
        </div>
        <van-button
          type="primary"
          @click="handleRechargeAgreementConfirm"
          color="#000"
          style="height: 40px; margin-top: 20px;"
          block
          round
          >同意并充值</van-button
        >
        <van-button
          type="primary"
          class="recharge-agreement-popup-cancel-button"
          @click="rechargeAgreementPopupVisible = false"
          color="#FFFFFF"
          style="height: 40px; margin-top: 8px; color: #86909C;"
          block
          round
          >不同意</van-button
        >
      </div>
    </Popup>

    <!-- 通知弹窗 -->
    <notification-popup
      v-model="showNotificationPopup"
      :title="notificationTitle"
      @confirm="handleNotificationConfirm"
      confirm-text="我知道了"
      :content="notificationContent"
    />
  </div>
</template>

<script>
import StatusPopup from "@/components/StatusPopup.vue";
import AgreementPopup from "@/components/AgreementPopup.vue";
import NotificationPopup from "@/components/NotificationPopup.vue";
import { Checkbox } from "vant";
import vipAgreementContent from "./vip_service_agreement";
import {
  fetchBalanceCenter,
  pay_point,
  getWeOpenId,
  fetchServerTime,
  checkUserIndentity,
  getOrderInfo,
  userInfoDetail,
  getRealNameAuthUrl,
  updateUserVisitStatus,
} from "../../api/theApi";
import { Notify, Dialog, Popup, Toast } from "vant";
export default {
  name: "SubscriptionPage",
  components: {
    StatusPopup,
    AgreementPopup,
    Popup,
    [Checkbox.name]: Checkbox,
    NotificationPopup,
  },
  data() {
    return {
      orderId: "",
      userName: localStorage.getItem("username"),
      totalBalance: 0,
      totalServerTime: 0,
      activeTab: this.$route.query.activeTab || "credit",
      qrDate1: new Date(),
      serverTab: 3,
      balanceTab: 4,
      serverList: [],
      balanceList: [],
      customAmount: "",
      openId: "",
      code: "",
      appid: "wwbffe857fac9e6bbc",
      agentId:
        location.origin === "https://fingpt.ainvestcn.com"
          ? "1000002"
          : "1000003",
      invitationCode: "",
      phone: "",
      isWechat: false,
      isPaying: false,
      statusPopupVisible: false,
      statusPopupType: "",
      statusPopupTitle: "",
      statusPopupDescription: "",
      statusPopupAutoClose: 3000,
      agreementPopupVisible: false,
      isIdentityVerified: false,
      riskPopupVisible: false,
      qrCodeVisible: false,
      paymentStatusPopupVisible: false,
      paymentErrorPopupVisible: false,
      isCheckingPayment: false,
      userInfo: {},
      isAgreementChecked: false,
      riskContent: `感谢您选择金声玉亮量化技术服务。为了使您更好地了解相关业务的基础知识和相关风险，根据有关法律、法规的规定，金声玉亮特向您进行如下风险揭示，请您仔细阅读并签署：<br>
1、本公司承诺提供专业技术服务，不承诺客户获取投资收益，也不与客户约定分享投资收益或分担投资损失。<br>
2、本公司所有视频、文字图表、技术服务均仅代表机构或者个人观点，仅供辅助作用。投资者应当充分了解市场规则，做出使用决策并独立承担风险。<br>
3、建议不要透支、借贷进入资本市场，不要用“必须的基本生活费用”来投入市场，只有用闲钱进行投资，心态才会相对稳定。<br>
4、本公司提供的证券相关资讯具有针对性和时效性，不能在任何市场环境下长期有效。<br>
5、客户应向本公司提供有效的联系方式和服务获取方式，如有变动须及时向本公司进行说明，如因客户自身原因或不可抗力因素导致未能及时获取本合同约定的相关技术服务，责任将由客户自行承担。<br>
6、客户应保管好从本公司获取的登录本公司网络平台的账号及密码，不得私自接受本公司员工的个人咨询服务，否则由此导致的风险将由客户自行承担。<br>
7、金声玉亮是以网络平台工具、软件工具、终端设备等为载体，向客户提供技术或者类似功能服务，您必须了解其实际功能、信息来源、固有缺陷和使用风险，由于您自身原因导致该网络平台工具、软件工具、终端设备等使用不当或受到病毒入侵、黑客攻击等不良影响的， 由此导致的风险将由您自行承担。<br>
  7.1、金声玉亮必须借助于PC/手机终端、互联网络，接收数据及信息。<br>
  7.2、金声玉亮存在因软硬件故障、互联网接入故障、服务器故障等原因导致软件无法接收数据的可能。<br>
  7.3、金声玉亮需数据信息支持。<br>
  7.4、金声玉亮不能完全准确的预测证券市场走势，我们提供的证券投资建议能为投资者提供一定的参考，但不能承诺投资收益，且具体决策须由投资者自行作出。<br>
8、股市有风险，投资需谨慎。<br>

本风险揭示书的揭示事项仅为列举性质，未能详尽列明投资者接受证券投资顾问服务所面临的全部风险和可能导致投资者投资损失的所有因素。<br>

特别提示：请您在充分知晓并理解上述《风险提示书》的前提下，签署本风险揭示书。`,
payContent:`<div style="font-family: '微软雅黑', Arial, sans-serif; font-size: 15px; color: #222; line-height: 1.8;">
  <h2 style="text-align: center;">大模型及算法备案信息公示</h2>
  <p>亲爱的用户，欢迎您使用金声玉亮产品及服务！</p>
  <p>金声玉亮产品及服务由上海亿熵智能科技有限公司、北京未来级数科技有限公司及其关联公司（以下简称“我们”或“金声玉亮”）共同所有和负责运营。</p>
  <p>我们提供的生成式人工智能产品和服务以金声玉亮大语言模型为基础。金声玉亮大语言模型架构基于先进的 Transformer，这一架构以其强大的并行计算能力和灵活的序列建模能力，为模型处理复杂语言任务奠定了基础。在训练过程中，选用英伟达 A800 作为 GPU，训练框架采用 PyTorch，其动态计算图和丰富的库函数，为模型的开发和调试带来了极大的便利，也使得模型能够更好地适应不同的硬件环境和任务需求。</p>

  <h3>金声玉亮模型及算法备案的公示信息如下：</h3>
  <table border="1" cellspacing="0" cellpadding="8" style="border-collapse: collapse; width: 100%; margin: 12px 0;">
    <thead style="background: #f5f5f5;">
      <tr>
        <th>备案类型</th>
        <th>备案名称</th>
        <th>备案号</th>
        <th>公示链接</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>生成式人工智能服务备案</td>
        <td>金声玉亮</td>
        <td>Shanghai-JinShengYuLiang-202503260042</td>
        <td><a href="https://jswx.gov.cn/csj/sh/202504/t20250425_3562055.shtml" target="_blank">备案地址</a></td>
      </tr>
      <tr>
        <td>深度合成服务算法备案</td>
        <td>金声玉亮大模型算法</td>
        <td>网信算备310104666296401240017号</td>
		<td>备案号 沪ICP备2024069186号-3</td>
        <td><a href="https://www.cac.gov.cn/2024-08/05/c_1724541639039621.htm" target="_blank">备案地址</a></td>
      </tr>
    </tbody>
  </table>
  <h2 style="text-align: center;">软件许可及技术服务合同</h2>
<p>甲方： 北京未来级数科技有限公司<br>乙方： 用户</p>
<p>(在本合同中，乙方、甲方单独称 “一方”，合称 “双方”)</p>

<p>鉴于：</p>
<p>甲方作为专业的大数据供应、软件开发以及软件服务提供商，拥有软件[“软件”]的所有权利并有能力提供相应的数据库与数据服务[“数据服务”]，能够提供其所自主开发并拥有的软件许可升级、安装、调试、维护、增强和使用培训服务以及提供相应的数据。</p>
<p>乙方因自身需要，同意按照本合同约定，向甲方定购使用该软件，并接收甲方加工、整理和传送的数据使用端口。</p>
<p>以本合同的条款和条件为前提，甲方同意向乙方授予软件的许可，并向乙方提供其所定购的数据。为了维护甲乙双方的正当权益，根据相关法律法规，在平等自愿的基础上，经甲乙双方协商一致，特订立此合同，共同遵守。</p>

<h3>定义</h3>
<p>在本合同中，除非另有定义或上下文另有要求，下列术语有以下含义：</p>
<ul>
  <li>“软件”：指甲方提供给乙方的所有计算机程序以及该等程序的所有更新版本。</li>
  <li>“数据服务”：指甲方整理加工并及时传送给乙方的所有数据以及数据的更新，其中也包括第三方的数据与数据传送服务。</li>
  <li>“合同”：指本《软件许可及技术服务合同》及所有附件，这些附件为本合同不可分割的组成部分。</li>
  <li>“机密信息”：双方标记为机密的各种商业秘密和机密信息，包括但不限于软件、文件、任何一方在履行本合同期间获得的涉及对方商业、未来产品或计划的任何信息或文件，以及甲方或乙方希望不要随意泄露或防止竞争性使用的信息，或者信息披露方指定为机密的信息。</li>
  <li>“增强”：因软件的技术或需求缺陷而对原版本的更新与修改。</li>
  <li>“故障”：软件整体或部分发生故障，不符合其技术规范。</li>
  <li>“人民币”：指人民币，中国的法定货币。</li>
</ul>

<h3>软件许可升级及数据服务</h3>
<ol>
  <li><strong>定购：</strong>根据本合同的条款与条件，乙方向甲方定购《采购订单及补充协议》所列的产品和服务。</li>
  <li><strong>授予软件许可：</strong>根据本合同的条款与条件，甲方在此同意授予并且乙方同意接受一份非独家性的软件使用许可，以便乙方在本合同约定期限内为其业务用途使用软件，并且接受软件的调试、维护、增强等服务内容。未经甲方事先书面同意，乙方不得将使用许可转移或授权给乙方之外的任何第三方。如果乙方未经甲方事先书面同意转移或授权给乙方之外的任何第三方使用，甲方有权立即解除本合同。</li>
  <li><strong>授予数据服务：</strong>根据本合同的条款与条件，甲方在此同意授予并向乙方传送该软件所需要的非独家性的数据，以便乙方在本合同约定期限内为其业务用途使用。</li>
  <li><strong>限制：</strong><br>
    （1）未经甲方事先书面同意，乙方不得对软件的任何部分进行修改、翻译、反向工程、反编译、反汇编或基于此软件或文件制造派生产品；也不得删除此软件或文件上的任何所有权声明或标签。<br>
    （2）乙方订购甲方软件的使用地域及网络出口均限于中国大陆地区内（港澳台、海外除外）。<br>
    （3）乙方使用和利用甲方软件或数据不能损害甲方的利益和业务模式，如甲方发现乙方违反此条款，甲方有权立即解除本合同，不退还乙方已支付的费用。<br>
    （4）乙方应限制在指定安装的机器上通过甲方提供的软件界面查询或提取数据，禁止通过第三方或乙方自己开发的插件或其它工具提取数据。<br>
    （5）在使用过程中乙方接受并遵守甲方软件系统的数据下载量限制条件，甲方享有下载量限制条件的最终解释权。</li>
  <li><strong>权利：</strong>甲方声明并保证本合同约定的软件及数据服务的任何资格及所有权益均为甲方或其供应者/提供方的专有财产。</li>
</ol>

<h3>服务</h3>
<ol>
  <li><strong>服务履行：</strong>甲方承诺在本合同约定期限内，优质、高效地履行本合同所规定的服务。</li>
  </ol>
<h3>配合</h3>
  <ol>
  <li>甲方应为乙方提供相关软件产品及相应的技术文档，有责任对乙方相关人员进行管理、操作、使用及技术培训。</li>
  <li>乙方应按甲方要求提供合同所约定的软件产品所需的硬件设备及硬件环境，并有责任为甲方提供便利的工作条件。</li>
  <li>乙方有责任为甲方的实施工作进行内部各部门、各营业部的协调，调动相关资源，配合甲方按进度完成项目实施。</li>
  <li>甲方在对乙方的服务实施工作中如需要与乙方内部网络环境或软件有关系的第三方进行沟通，乙方有责任联系、协调。</li>
  <li>甲方应不定期对软件产品进行自动升级，因乙方网络设置等原因导致升级不成功而出现的软件故障，由乙方负责解决。</li>
  </ol>
  <h3>安装、培训与其他服务</h3>
  <ol>
    <li>
      <strong>安装：</strong>软件应由甲方为乙方进行安装。甲方的安装人员应经过培训，至少能够达到软件当前版本的安装资格要求。安装时应将对乙方正常经营活动所造成的影响降至最低限度，保持现场安全、清洁、有序。完成安装后，甲方应使现场保持清洁，不留下安装完成后不再需要的任何甲方的材料、工具及因安装所产生的垃圾和废物。
    </li>
    <li>
      <strong>培训：</strong>有关软件操作的培训在软件安装之后由甲方向乙方提供，具体时间由甲乙双方另行协商确定。
    </li>
    <li>
      <strong>其它服务：</strong>除在此描述的服务之外，甲方还可以根据乙方的要求并在甲方同意的条件下，向乙方提供其它服务。
    </li>
  </ol>

<h3>其它保证和责任范围</h3>
<ol>
  <li><strong>软件保证：</strong>甲方声明并保证整个软件均符合其技术规范，如果在本合同约定期限内软件有故障，甲方应在收到乙方通知后24个小时内采取适当方式处理。对于非因乙方原因导致的服务中断，甲方将按服务中断时间为乙方免费顺延相同时间的使用期限。</li>
  <li><strong>遵循法律：</strong>甲方保证，在软件及服务授权许可合同约定期限内，均符合所有可适用的法律、法规、规范性文件的要求。</li>
  <li><strong>询问帮助：</strong>在本合同约定期限内，甲方提供及时响应的服务，甲方应在收到乙方的电话询问或请求服务时为乙方提供帮助，答复有关软件的问题；或向专家咨询以获得解决故障的协助；或尽力找出一个临时性的故障解决方案或应急的代替方法。</li>
  <li><strong>数据传输：</strong>甲方尽最大诚信和努力收集及传送数据，甲方不对收集数据的真实性及传输过程中发生的传送错误承担除更正以外的法律责任，甲方不承担因数据错误或者传送错误造成乙方及乙方客户业务所受的直接利益和期待利益损失。</li>
  <li><strong>除外责任：</strong>除上述明示的保证之外，甲方没有明示或暗示同意任何其它保证，包括但不限于甲方提供给乙方的所有信息和数据仅供乙方及乙方客户参考，甲方不承担乙方或乙方客户由此而导致的任何责任，乙方有责任知会其所有使用者。</li>
</ol>

<h3>机密信息</h3>
<ol>
  <li><strong>信息获取及保护：</strong>在本合同约定期限内，甲方和乙方均可能知晓对方的机密信息（包括但不限于本合同及附件、公司计划、运营活动、财务信息、技术信息、经营信息）。除法律规定及合同另有特别约定外，未经信息提供方书面同意，双方当事人及双方的管理人员、雇员及代理商，都应严格保守对方的机密信息，并采取必要措施以防止机密信息未经授权即被泄露、复制或使用。</li>
  <li><strong>归还：</strong>收到机密信息的一方在收到披露方的请求后，应立即将占有或控制（如有）的所有披露方机密信息归还给披露方，如果本合同根据规定被解除或终止，则任何一方须自行归还、销毁或删除从对方获取的信息、文件和软件等载体。</li>
  <li><strong>保密：</strong>双方的保密义务不因本合同的解除、终止及无效而免除。</li>
  <li><strong>例外：</strong>为履行本合同起见，以下信息不被视为机密信息：在对方收到时已为公众所知的信息；从其它渠道合法获得的信息；遵照有司法管辖权的法院或者其他监管机构的要求必须告知的信息；披露方放弃保密性的信息。</li>
</ol>

<h3>版权</h3>
<ol>
  <li>甲方对合同涉及的软件产品及相关文档、信息拥有独立版权。乙方不得转让/许可第三方使用或者作合同目的以外的使用。</li>
  <li>乙方不得自行复制、仿制甲方相关软件产品。乙方不得自行修改软件。乙方未经许可自行复制、仿制或修改的，由此产生的一切使用中的责任均由乙方承担。</li>
</ol>

<h3>终止</h3>
<ol>
  <li>除以上所述的终止权外，如果任何一方违背了本合同包含或引用的任何重要陈述、担保、合同或义务，若守约方书面通知对方此类严重违约，且违约方在收到此通知后未能在30天内纠正违约事实，则守约方可以提前通知对方终止本合同。本合同自守约方发出该通知之日即行终止，在此情况下，守约方无需承担任何违约或赔偿责任。</li>
</ol>

<h3>违约责任及争议解决</h3>
<ol>
  <li>除本合同特别约定之外，任何一方违反本合同约定的，均应根据相关法律法规向守约方承担违约责任。</li>
  <li>因本合同产生或与此有关的任何争议应首先通过协商解决。如该等争议发生后30日内双方通过友好协商未能解决该等争议，双方同意将该等争议提交有管辖权的人民法院进行解决。</li>
  <li>因乙方原因导致本合同被提前解除，甲方将不退还乙方已经支付的服务费用。</li>
  <li>甲方于本合同项下所应承担的违约责任及过错责任（包括但不限于：违约金、赔偿金、实际损失等），累计不得超过本合同标的金额。</li>
</ol>

 <h3>其他事项</h3>
  <ol>
    <li><strong>通知：</strong>如果通知以书面形式被投递到本合同签字页上所注明的地址，根据本合同，即被视为送达到对方。该地址如有变动，各方应书面形式通知对方。</li>
    <li><strong>标题：</strong>本合同中的所有标题仅作引用之用，且其中包含的词语不得以任何形式被解释、修改、放大或帮助对本合同的条款进行说明、解释或阐明。</li>
    <li><strong>可分割性：</strong>如果本合同的任何条件或条款被有司法管辖权的法院以任何程度禁止或不能执行，合同的其余部分将不受影响，每一条款在法律许可的最大范围内均有效。</li>
    <li><strong>修改：</strong>除非双方的法定代表人或授权签字人签字并加盖公章，任何对本合同的修改或修正以及对合同中任何条款的放弃均被视为无效。</li>
    <li><strong>授权：</strong>甲方和乙方均有全部权利签订并履行本合同。代表双方签订本合同的代表经适当授权，有权签订本合同。</li>
    <li><strong>独立关系：</strong>本合同包含的任何内容均不构成甲方和乙方之间形成合资关系、伙伴关系或者雇佣关系的暗示。任何一方均没有任何权利、特权给对方形成任何义务，不管是明示的还是暗示的，除非本合同另有规定或者双方根据本合同的条款同意。</li>
    <li><strong>不可抗力：</strong>双方均不对因各方合理控制以外的事件而引起的履行义务的延迟或不能履行义务承担责任。此类事件应包括但不限于罢工、暴乱、战争、流行病、公共卫生事件、政府行为、火灾、停电、核事故、地震、异常气候、突发性网络故障、黑客攻击、软件病毒或其它灾难，无论是否与上述事项类似。</li>
  </ol>
  <h3>继续有效</h3>
  <ol>
  <li>本合同所包含的、双方认为其有效时间比本合同期限更长的条件、条款及保证，应在履行完本合同、取消或终止本合同之后继续生效。</li>
  </ol>
  <h3>份数</h3>
  <ol>
    <li>本协议以数据电文的形式体现，不提供纸质协议，乙方本人点击签署合同即生效。本协议保存在甲方指定位置，甲乙双方认可该形式的协议效力及本协议内容。</li>
  </ol>
  <p>（以下无正文）</p>
  <h3>甲方：北京未来级数科技有限公司</h3>
  <p>地址：北京市西城区茶马北街1号院1号楼10层2单元1121</p>
  <h3>乙方：用户</h3>
</div>`,
      vipAgreementPopupVisible: false,
      vipAgreementContent: vipAgreementContent.content,
      rechargeAgreementPopupVisible: false,
      showStatusPopupConfirmButton: false,
      showStatusPopupCancelButton: false,
      statusPopupConfirmButtonText: "立即前往",
      statusPopupCancelButtonText: "暂不前往",
      showNotificationPopup: false,
      notificationTitle: "签约投顾服务通知",
      notificationContent:
        "您的签约将在1-2个工作日完成，完成后将短信通知您签约状态。",
    };
  },
  computed: {
    qrDate2() {
      // Create a new date by adding 7 days to qrDate1
      const date = new Date(this.qrDate1.getTime());
      date.setDate(date.getDate() + 7);
      return date;
    },
    customPrice() {
      return +this.customAmount > 0
        ? `${(this.customAmount * 100).toFixed(0)}`
        : "";
    },
  },
  created() {
    if (Object(this.$route.query).hasOwnProperty("iv")) {
      this.invitationCode = this.$route.query.iv;
    }
    if (Object(this.$route.query).hasOwnProperty("p")) {
      this.phone = sysTools.b64decode(this.$route.query.p);
    }
  },
  async mounted() {
    this.getUserInfo();
    await this.init();
    let vm = this;
    if (Object(this.$route.query).hasOwnProperty("orderId")) {
      this.orderId = this.$route.query.orderId;
      if (Object(this.$route.query).hasOwnProperty("error_code")) {
        // 显示支付错误窗口
        this.paymentErrorPopupVisible = true;
      } else {
        // 显示支付状态查询弹窗
        this.paymentStatusPopupVisible = true;
      }
      
      if (this.orderId) {
        const query = { ...this.$route.query };
        delete query.orderId;
        this.$router.replace({ query });
        this.orderId = "";
      }
    }
  },
  methods: {
    async getUserInfo() {
      const res = await userInfoDetail(this.userName);
      if (res.code === 20000) {
        this.userInfo = res.data.userInfo;
      }
    },
    async handleNotificationConfirm() {
      this.showNotificationPopup = false;
      await updateUserVisitStatus({uid: this.userName, type: 7});
      location.href = this.userInfo.investAgencyURL;
    },
    onVipAgreementClose() {
      this.vipAgreementPopupVisible = false;
    },
    showVipAgreement() {
      this.vipAgreementPopupVisible = true;
    },
    showQrCode() {
      this.qrCodeVisible = true;
    },
    async init() {
      try {
        const [res, { data }] = await Promise.all([
          checkUserIndentity(this.userName),
          fetchBalanceCenter(this.userName),
        ]);
        if (res.code === 20000) {
          this.isIdentityVerified = res.data;
        }
        this.serverList = data.serverTimePlans;
        this.balanceList = data.balancePlans;
        this.totalBalance = data.totalBalance;
        this.totalServerTime = data.totalServerTime;
        if (!this.totalBalance) {
          this.activeTab = "credit";
        } else {
          this.activeTab = "service";
        }
      } catch (error) {}
    },
    goBack() {
      // 跳转到用户页面
      this.$router.replace("/user");
    },
    goToRechargeHistory() {
      this.$router.push("/recharge-history");
    },
    async redeem() {
      if (this.activeTab === "credit") {
        if (
          (typeof this.balanceTab !== "number" && !this.balanceTab) ||
          this.balanceTab > this.balanceList.length
        ) {
          Notify({ type: "warning", message: "请选择充值金额" });
          return;
        }
        if (
          +this.customAmount < 1 &&
          this.balanceTab === this.balanceList.length
        ) {
          Notify({ type: "warning", message: "请输入不小于1的算力值" });
          return;
        }
        if (!this.isAgreementChecked) {
          this.rechargeAgreementPopupVisible = true;
          return;
        }
        this.toPay();
      } else {
        if (
          (typeof this.serverTab !== "number" && !this.serverTab) ||
          this.serverTab >= this.serverList.length
        ) {
          Notify({ type: "warning", message: "请选择套餐" });
          return;
        }
        if (!this.isIdentityVerified) {
          this.showIdentityVerificationPopup();
        } else {
          this.riskPopupVisible = true;
        }
      }
    },
    async showIdentityVerificationPopup() {
      const res = await getRealNameAuthUrl(this.userName);
      if (res.code === 20000) {
        window.location.href = res.data;
      } else {
        Toast.fail(res.msg || "获取实名认证URL失败， 请稍后再试");
      }
    },
    async toPay() {
      try {
        if (this.isPaying) {
          return;
        }

        let price;
        if (this.balanceTab < this.balanceList.length) {
          price = this.balanceList[this.balanceTab].price;
        } else {
          price = this.customPrice;
        }
        this.isPaying = true;
        const rslt = await pay_point({
          platform: "sqb",
          price,
        });
        if (rslt.code === 20000) {
          location.replace(rslt.data);
        } else {
          Toast.fail(rslt.msg);
        }

        this.isPaying = false;
      } catch (error) {
        console.warn(error);
        Dialog.alert({ message: JSON.stringify(error) });
      }
    },

    showStatusPopup(
      type,
      title,
      description,
      autoClose = 3000,
      showStatusPopupConfirmButton = false,
      showStatusPopupCancelButton = false,
      statusPopupConfirmButtonText = "立即前往",
      statusPopupCancelButtonText = "暂不前往"
    ) {
      this.statusPopupType = type;
      this.statusPopupTitle = title;
      this.statusPopupDescription = description;
      this.statusPopupAutoClose = autoClose;
      this.showStatusPopupConfirmButton = showStatusPopupConfirmButton;
      this.showStatusPopupCancelButton = showStatusPopupCancelButton;
      this.statusPopupConfirmButtonText = statusPopupConfirmButtonText;
      this.statusPopupCancelButtonText = statusPopupCancelButtonText;
      this.statusPopupVisible = true;
    },
    initScope() {
      let url = location.href;
      location.href =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        this.appid +
        "&redirect_uri=" +
        encodeURI(url) +
        "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirec&agentid=" +
        this.agentId;
    },
    async getOpenId() {
      if (!!localStorage.getItem("wx_openid")) {
        this.openId = localStorage.getItem("wx_openid");
        return;
      }
      try {
        let rslt = await getWeOpenId({
          code: this.code,
          agentId: this.agentId,
        });
        this.isPaying = false;
        if (rslt.errcode) {
          this.openId = localStorage.getItem("wx_openid");
        } else {
          if (!!rslt.data.openid) {
            this.openId = rslt.data.openid;
            localStorage.setItem("wx_openid", rslt.data.openid);
          }
        }
      } catch (error) {
        Dialog.alert({ message: JSON.stringify(error) });
      }
    },
    async showIdentityVerification() {
      const res = await getRealNameAuthUrl(this.userName);
      if (res.code === 20000) {
        window.location.href = res.data;
      } else {
        Toast.fail(res.msg || "获取实名认证URL失败， 请稍后再试");
      }
    },
    toWepay(rslt) {
      if (rslt.code === 20000) {
        this.onBridgeReady(rslt.data);
      } else {
        Notify({ type: "warning", message: rslt.msg });
      }
    },
    onBridgeReady(data) {
      if (typeof WeixinJSBridge === "undefined") {
        Notify({ type: "warning", message: "请在微信内打开" });
      } else {
        this.invokeWePay(data);
      }
    },
    invokeWePay(data) {
      let vm = this;
      data.openid = this.openId || localStorage.getItem("wx_openid");
      WeixinJSBridge.invoke("getBrandWCPayRequest", data, (res) => {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          Notify({
            type: "success",
            message: "支付成功",
          });

          vm.init();
        } else {
          Notify({ type: "warning", message: "支付失败" });
        }
      });
    },
    onStatusPopupClose() {
      this.statusPopupVisible = false;
    },
    onAgreementPopupClose() {
      this.agreementPopupVisible = false;
    },
    showAgreementDemo() {
      this.agreementPopupVisible = true;
    },
    showAgreement() {
      this.agreementPopupVisible = true;
    },
    async toExchangeTime() {
      const res = await fetchServerTime(
        this.userName,
        this.serverList[this.serverTab].id
      );
      if (res.code === 20000) {
        this.init();
        if (!this.userInfo.securitiesSettingStatus) {
          this.showStatusPopup(
            "success",
            "兑换成功",
            "关联券商账户以开通交易权限",
            0,
            true,
            true,
            "去关联",
            "以后再说"
          );
          return;
        }
        if (
          !this.userInfo.investAgencySignStatus ||
          this.userInfo.investAgencySignType === "2"
        ) {
          this.showStatusPopup(
            "success",
            "兑换成功",
            "根据合规要求，需签约投顾服务后方可启用AI策略自动交易。",
            0,
            true,
            true,
            "去签约",
            "以后再说"
          );
          return;
        }
        this.showStatusPopup("success", "兑换成功", "");
      } else {
        Notify({ type: "danger", message: res.msg });
      }
    },
    onStatusPopupConfirm() {
      this.statusPopupVisible = false;
      if (this.statusPopupDescription === "关联券商账户以开通交易权限") {
        this.$router.push("/userConfig");
      } else if (
        this.statusPopupDescription ===
        "根据合规要求，需签约投顾服务后方可启用AI策略自动交易。"
      ) {
        this.showNotificationPopup = true;
      }
    },
    onStatusPopupCancel() {
      this.statusPopupVisible = false;
    },
    // 处理协议确认后的逻辑
    async handleAgreementConfirm() {
      this.agreementPopupVisible = false;
      this.toExchangeTime();
    },
    handleAgreementCancel() {
      // 处理协议取消后的逻辑
      this.agreementPopupVisible = false;
      this.riskPopupVisible = true;
    },
    handleCustomAmountInput(event) {
      // 处理输入框输入事件，只允许输入大于0的正整数
      let value = event.target.value;

      // 移除所有非数字字符
      value = value.replace(/[^\d]/g, "");

      // 如果是空值，允许（用户正在输入过程中）
      if (value === "") {
        this.customAmount = "";
        return;
      }

      // 转换为数字并验证
      const numValue = parseInt(value);

      // 只允许大于0的整数
      if (numValue > 0) {
        this.customAmount = numValue.toString();
      } else {
        // 如果输入0或负数，保持为空或恢复到之前的有效值
        this.customAmount = this.customAmount || "";
      }

      // 更新input的值，确保显示和数据一致
      event.target.value = this.customAmount;
    },
    handleKeyDown(event) {
      // 处理输入框按键事件
      const key = event.key;

      // 只允许数字、退格、删除、方向键等
      const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End",
        "Tab",
        "Enter",
      ];

      // 阻止非数字字符输入（除了允许的特殊键）
      if (!allowedKeys.includes(key) && !/^\d$/.test(key)) {
        event.preventDefault();
        return;
      }

      // 回车键触发支付
      if (
        key === "Enter" &&
        this.customAmount &&
        parseInt(this.customAmount) > 0
      ) {
        event.preventDefault();
        this.redeem();
      }
    },
    handlePaste(event) {
      // 处理粘贴事件
      event.preventDefault();
      const pasteData = event.clipboardData.getData("text");

      if (pasteData) {
        // 移除所有非数字字符
        let cleanValue = pasteData.replace(/[^\d]/g, "");

        // 如果粘贴的是空值，直接返回
        if (cleanValue === "") {
          return;
        }

        // 转换为数字并验证
        const numValue = parseInt(cleanValue);

        // 只允许大于0的整数
        if (numValue > 0) {
          this.customAmount = numValue.toString();
        }
      }
    },
    handleRiskConfirm() {
      this.riskPopupVisible = false;
      this.showAgreementDemo();
    },
    handleRiskCancel() {
      this.riskPopupVisible = false;
    },
    handleRechargeAgreementConfirm() {
      this.rechargeAgreementPopupVisible = false;
      this.toPay();
    },
    // 处理支付确认
    async handlePaymentConfirm(isPaid) {
      if (isPaid) {
        // 用户选择已支付完成，查询订单状态
        this.isCheckingPayment = true;
        try {
          const result = await getOrderInfo(this.orderId);
          this.isCheckingPayment = false;
          this.paymentStatusPopupVisible = false;

          // 根据返回的状态码显示相应的Toast消息
          if (result.code === 20000) {
            if (result.success === true) {
              if (result.data === "支付成功") {
                Toast.success("支付成功");
              } else if (
                result.data &&
                result.data.payStatus === "支付中" &&
                result.data.paid === false
              ) {
                Toast("支付中");
              }
            }
          } else if (result.code === -1) {
            // Toast.fail(result.msg || "支付取消");
          } else {
            // Toast.fail(result.msg || "查询失败");
          }

          // 调用init方法获取最新页面状态
          await this.init();
        } catch (error) {
          this.isCheckingPayment = false;
          this.paymentStatusPopupVisible = false;
          console.error("查询订单状态错误:", error);
        }
      } else {
        // 用户选择稍后支付，直接关闭弹窗
        this.paymentStatusPopupVisible = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.subscription-page {
  position: relative;
  box-sizing: border-box;
  min-height: 100dvh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

/* Header Styles */
.header {
  background-color: #111;
  padding: 16px;
  color: white;
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  padding-bottom: 20px;
}

.back-button {
  img {
    width: 24px;
    height: 24px;
  }
}

.user-info-container {
  margin-top: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  width: 100%;

  .user-info {
    flex: 1;

    h1 {
      font-size: 28px;
      font-weight: 500;
      margin: 0;
    }
  }
}

.recharge-button {
  background-color: transparent;
  border: 1px solid #ffa500;
  color: #ffa500;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
}

/* User Stats Styles */
.user-stats {
  margin-top: 20px;
  width: 100%;
  background-color: #222;
  border-radius: 8px;
  padding: 12px 20px;
  display: flex;
  justify-content: space-between;
  color: white;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stat-item {
  flex: 1;

  .stat-label {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 8px;
  }

  .stat-value {
    font-size: 20px;
    font-family: PingFangSC-bold;
  }
}

/* Subscription Container Styles */
.subscription-container {
  flex-shrink: 0;
  min-height: calc(100dvh - 293px - env(safe-area-inset-bottom));
  background-color: white;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 20px 0 20px 28px;
  border-radius: 8px 8px 0 0;
  &.is-credit {
    min-height: calc(100dvh - 328px - env(safe-area-inset-bottom));
  }
}

/* Tab Styles */
.tab-container {
  margin-bottom: 20px;
  margin-right: 28px;
  position: relative;
  &.is-credit {
    margin-bottom: 16px;
  }
}

.tab-slider {
  display: flex;
  background-color: #f5f5f5;
  border-radius: 30px;
  padding: 4px;
  position: relative;
}

.tab {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  font-size: 14px;
  color: #666;
  border-radius: 30px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  font-weight: 500;

  &.active {
    color: #333;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

/* Plan Card Styles */
.plans-container {
  padding-top: 8px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.tip-container {
  margin-top: 20px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #000000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  .tip-button {
    margin-left: 4px;
    color: #8c5800;
    font-family: PingFangSC-Bold;
    font-weight: 700;
  }
}

.plan-card {
  width: 141px;
  margin-right: 12px;
  flex-shrink: 0;
  background-color: #fcfcfc;
  border-radius: 8px;
  padding: 24px 12px 14px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;

  &.active {
    border: 2px solid #f5b646;
    background: #f5b6460d;
  }
}

.discount-label {
  position: absolute;
  top: -10px;
  left: -2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, #452b1b 0%, #836c4a 48.5%, #3c2114 100%);
  color: #ffd86f;
  font-size: 12px;
  font-weight: 600;
  width: 88px;
  /* max-width: 100px; */
  height: 24px;
  border-radius: 8px 8px 8px 0;
}

.plan-duration {
  font-size: 14px;
  line-height: 1.3;
  font-family: PingFangSC-Semibold;
  .time-tag {
    padding: 0 2px;
    margin-left: 6px;
    border-radius: 2px;
    background: #0000001a;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    color: #000000;
  }
}

.plan-price {
  margin-top: 8px;
  font-size: 20px;
  font-family: PingFangSC-Semibold;

  .price-unit {
    font-size: 12px;
    line-height: 1.3;
    margin-left: 4px;
    font-family: PingFangSC-Regular;
    color: #666;
  }
}

.plan-description {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  .plan-description-item {
    font-weight: 400;
    font-size: 12px;
    line-height: 1.7;
    letter-spacing: 0px;
    color: #000000b2;
    font-family: PingFangSC-Regular;
  }
}

.original-price {
  font-size: 14px;
  color: #999;
  text-decoration: line-through;
  margin-top: 8px;
}

.checkbox-wrapper {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  user-select: none;
}

.checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid #ddd;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;
  position: relative;

  &.checked {
    background-color: #000;
    border-color: #000;
  }

  .checkmark {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    svg {
      width: 10px;
      height: 8px;
    }
  }
}

.agreement-text {
  .agreement-text-link {
    color: #8c5800;
  }
  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  color: #1d2129;
  flex: 1;
}

/* Redeem Button Styles */
.redeem-button-container {
  margin-top: 20px;
  &.is-credit {
    margin-top: 16px;
  }
}

.redeem-button {
  background-color: black;
  color: white;
  border: none;
  border-radius: 30px;
  width: 100%;
  padding: 16px;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.agreement-demo-button {
  background-color: transparent;
  border: 1px solid #ffa500;
  color: #ffa500;
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  margin-top: 12px;
  border-radius: 20px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    background-color: #ffa500;
    color: #ffffff;
  }

  &:active {
    transform: scale(0.98);
  }
}

.balance-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 12px;
  column-gap: 12px;
  margin-bottom: 16px;

  &.is-credit {
    padding-right: 28px;
  }

  .balance-card {
    background-color: #fcfcfc;
    border-radius: 8px;
    padding: 16px;
    border: 2px solid #0000000d;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    .title {
      font-family: PingFangSC-Bold;
      font-weight: 800;
      font-size: 24px;
      text-align: center;
      color: #000000;
      .title-unit {
        margin-left: 4px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 12px;
        line-height: 1.2;
        color: #00000080;
      }
    }

    .count {
      margin-top: 16px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .unit {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
      }
    }

    .price {
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 10px;
      line-height: 1.8;
      text-decoration: line-through;
      margin-left: 4px;
      color: #00000080;
      &.custom-price {
        margin-top: 16px;
        color: #000000;
        text-decoration: none;
      }
    }

    &.active {
      background: #f5b6460d;
      border: 2px solid #f5b646;
    }
  }

  .custom-balance {
    .count-input {
      width: 100%;
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      color: #000000;
      text-align: left;
      border: none; /* 移除常规边框 */
      outline: none; /* 移除聚焦时的轮廓线 */
      box-shadow: none; /* 清除可能存在的阴影边框 */
      /* 针对 Safari 的特殊处理 */
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      &::placeholder {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        color: #00000080;
      }
    }
  }
}

.recharge-agreement-popup {
  .recharge-agreement-title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #1d2129;
  }

  .recharge-agreement-popup-cancel-button {
    .van-button__content {
      .van-button__text {
        color: #86909c;
      }
    }
  }

  .recharge-agreement-content {
    .recharge-agreement-content-link {
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      font-size: 15px;
      line-height: 22px;
      text-align: center;
      color: #8c5800;
    }
    font-family: Inter;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    text-align: center;
    margin-top: 12px;
    color: #4e5969;
  }
}

.pay-content {
  border-top: 1px solid #0000001a;
  background-color: #fff;
  padding: 0 28px;
  width: 100%;
  padding-bottom: calc(constant(safe-area-inset-bottom) + 32px);
  padding-bottom: calc(env(safe-area-inset-bottom) + 32px);
}

.pay-bar {
  padding-top: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #000000;

  .pay-select {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    .wechat-icon {
      display: block;
      width: 28px;
      height: 28px;
    }
  }
}

.payment-status-popup {
  .payment-popup-title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #1d2129;
    margin-bottom: 8px;
  }

  .payment-popup-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #4e5969;
    text-align: center;
    margin-bottom: 24px;
  }

  .payment-popup-buttons {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
}

.payment-error-popup {
  .popup-header {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    text-align: center;
    color: #1d2129;
    margin-bottom: 8px;
  }

  .popup-body {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #4e5969;
    text-align: center;
    margin-bottom: 16px;
  }

  .popup-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 16px;

    .popup-cancel-btn,
    .popup-confirm-btn {
      flex: 1;
    }
  }
}

.wx-qrcode-popup {
  .wx-popup-title {
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    color: #1d2129;
  }
  .wx-popup-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #4e5969;
    margin-top: 8px;
    text-align: center;
  }
  .wx-popup-qrcode {
    margin: 12px auto 0;
    img {
      margin: 0 auto;
      display: block;
      width: 157px;
      height: 157px;
    }
  }
}
</style>
